<div class="mm-unsub">
  <div class="container">
    <div class="mm-unsub-card">

      <!-- loading -->
      <ng-container *ngIf="loading">
        <div class="mm-unsub-icon mm-unsub-icon-wait"><i class="fa fa-spinner fa-spin"></i></div>
        <p class="mm-unsub-text">{{ lang.isArabic ? 'جارٍ المعالجة…' : 'Processing…' }}</p>
      </ng-container>

      <!-- no/invalid token -->
      <ng-container *ngIf="!loading && (!token || (result && !result.found))">
        <div class="mm-unsub-icon mm-unsub-icon-warn"><i class="fa fa-exclamation-triangle"></i></div>
        <h1 class="mm-unsub-title">{{ lang.isArabic ? 'رابط غير صالح' : 'Invalid link' }}</h1>
        <p class="mm-unsub-text">
          {{ lang.isArabic
            ? 'رابط إلغاء الاشتراك غير صحيح أو منتهي الصلاحية.'
            : 'This unsubscribe link is invalid or has expired.' }}
        </p>
        <a routerLink="/index" class="mm-unsub-btn">{{ lang.isArabic ? 'العودة إلى الرئيسية' : 'Back to Home' }}</a>
      </ng-container>

      <!-- unsubscribed -->
      <ng-container *ngIf="!loading && result && result.found && !result.isActive">
        <div class="mm-unsub-icon mm-unsub-icon-ok"><i class="fa fa-check-circle"></i></div>
        <h1 class="mm-unsub-title">{{ lang.isArabic ? 'تم إلغاء الاشتراك' : 'You’ve been unsubscribed' }}</h1>
        <p class="mm-unsub-text">
          {{ lang.isArabic
            ? 'لن تتلقى بعد الآن رسائل النشرة الإخبارية على'
            : 'You will no longer receive newsletter emails at' }}
          <strong *ngIf="result.email">{{ result.email }}</strong>.
        </p>
        <p class="mm-unsub-sub">{{ lang.isArabic ? 'غيّرت رأيك؟' : 'Changed your mind?' }}</p>
        <button type="button" class="mm-unsub-btn" [disabled]="busy" (click)="resubscribe()">
          {{ busy ? (lang.isArabic ? '…' : '…') : (lang.isArabic ? 'إعادة الاشتراك' : 'Resubscribe') }}
        </button>
      </ng-container>

      <!-- resubscribed -->
      <ng-container *ngIf="!loading && result && result.found && result.isActive">
        <div class="mm-unsub-icon mm-unsub-icon-ok"><i class="fa fa-heart"></i></div>
        <h1 class="mm-unsub-title">{{ lang.isArabic ? 'تمت إعادة الاشتراك' : 'You’re resubscribed' }}</h1>
        <p class="mm-unsub-text">
          {{ lang.isArabic
            ? 'سعداء بعودتك! ستستمر في تلقي آخر أخبارنا.'
            : 'Great to have you back! You’ll keep receiving our updates.' }}
        </p>
        <a routerLink="/index" class="mm-unsub-btn">{{ lang.isArabic ? 'العودة إلى الرئيسية' : 'Back to Home' }}</a>
      </ng-container>

    </div>
  </div>
</div>
